export class SelectItems {
    constructor(public value: any, public name: string, public index: number) {}
}